import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { FaWhatsapp } from "react-icons/fa";

const Help = () => {
  const handleClick = () => {
    const currentUrl = window.location.href;
    const message = ` ${currentUrl}  تصفحت الموقع وأريد السؤال عن: `;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/+201068731962?text=${encodedMessage}`;
    window.open(whatsappUrl);
  };

  return (
    <Row className="my-5" style={{ direction: "ltr" }}>
      <Col className="text-center lead">
        <Button
          style={{
            backgroundColor: "#14A44D",
            color: "white",
            border: "white",
          }}
          onClick={handleClick}
        >
          <h2>
            {`Ask Me WhatsApp! `}
            <FaWhatsapp />
          </h2>
        </Button>
      </Col>
    </Row>
  );
};

export default Help;
